import { Routes } from '@angular/router';

export const purchaseReqRoutes: Routes = [
  {
    path: 'purchase-request',
    data: { moduleCode: 'proc_pr' },
    children: [
      { path: '', loadComponent: () => import('./purchase-request/purchase-request').then((m) => m.PurchaseRequest) },
      {
        path: 'add',
        loadComponent: () =>
          import('./purchase-request/purchase-request-details/purchase-request-details').then((m) => m.PurchaseRequestDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./purchase-request/purchase-request-details/purchase-request-details').then((m) => m.PurchaseRequestDetails)
      }
      //   { path: 'voucher-profile-import', component: VoucherImport }
    ]
  }
];
